export const RESET_WIDGET = 'resetWidget';